import ActualsPeriodColumnSource from "./ActualsPeriodColumnSource.js";
import BudgetPeriodColumnSource from "./BudgetPeriodColumnSource.js";
import ModelFactory from "../../../../ModelFactory.js";

/**
 * Factory creating instances of AbstractPeriodColumnSource.
 */
class PeriodColumnSourceFactory extends ModelFactory {
	allClasses() {
		return [ActualsPeriodColumnSource, BudgetPeriodColumnSource];
	}

	_findClassFromJson(json) {
		if (json.isBudgetColumn) {
			return BudgetPeriodColumnSource;
		}

		return ActualsPeriodColumnSource;
	}
}

const periodColumnSourceFactory = new PeriodColumnSourceFactory();

export default periodColumnSourceFactory;
